import { getRandomInt } from './calculations';

export async function getShipCooldown(workerId, token, shipSymbol) {
  return await run(workerId, 'get', `https://api.spacetraders.io/v2/my/ships/${shipSymbol}/cooldown`, token);
}

export async function getShip(workerId, token, shipSymbol) {
  return await run(workerId, 'get', `https://api.spacetraders.io/v2/my/ships/${shipSymbol}`, token);
}

export async function getShips(workerId, token) {
  return await run(workerId, 'get', `https://api.spacetraders.io/v2/my/ships?limit=20`, token);
}

export async function refuelShip(workerId, token, shipSymbol) {
}

export async function navigate(workerId, token, shipSymbol, waypointSymbol) {
  return await run(workerId, 'post', `https://api.spacetraders.io/v2/my/ships/${shipSymbol}/navigate`, token, {
    waypointSymbol
  });
}

export async function orbitShip(workerId, token, shipSymbol) {
  return await run(workerId, 'post', `https://api.spacetraders.io/v2/my/ships/${shipSymbol}/orbit`, token);
}

export async function dockShip(workerId, token, shipSymbol) {
  return await run(workerId, 'post', `https://api.spacetraders.io/v2/my/ships/${shipSymbol}/dock`, token);
}

export async function extract(workerId, token, shipSymbol) {
  return await run(workerId, 'post', `https://api.spacetraders.io/v2/my/ships/${shipSymbol}/extract`, token);
}

export async function getAgent(workerId, token) {
  return await run(workerId, 'get', `https://api.spacetraders.io/v2/my/agent`, token);
}

export async function getContracts(workerId, token) {
  return await run(workerId, 'get', `https://api.spacetraders.io/v2/my/contracts`, token);
}

/**
 * Fetch the system, and also give all moons a random offset
 */
export async function getSystem(workerId, token, systemSymbol) {
  const system = await run(workerId, 'get', `https://api.spacetraders.io/v2/systems/${systemSymbol}`, token);

  for (let waypoint of system.data.waypoints) {
    if (waypoint.type == 'MOON' || waypoint.type == 'ORBITAL_STATION') {

      const placement = getRandomInt(0, 4);
      let diffX = 0;
      let diffY = 0;

      if (placement == 0) {
        diffX += getRandomInt(50, 100);
        diffY -= getRandomInt(50, 100);
      } else if (placement == 1) {
        diffX -= getRandomInt(50, 100);
        diffY += getRandomInt(50, 100);
      } else if (placement == 2) {
        diffX -= getRandomInt(50, 100);
        diffY -= getRandomInt(50, 100);
      } else {
        diffX += getRandomInt(50, 100);
        diffY += getRandomInt(50, 100);
      }

      waypoint.diffX = diffX;
      waypoint.diffY = diffY;
    }
  }

  return system;
}

export async function jumpShip(workerId, token, shipSymbol, systemSymbol) {
  return await run(workerId, 'post', `https://api.spacetraders.io/v2/my/ships/${shipSymbol}/jump`, token, {
    systemSymbol
  });
}

export async function updateFlightMode(workerId, token, shipSymbol, mode) {
  return await run(workerId, 'patch', `https://api.spacetraders.io/v2/my/ships/${shipSymbol}/nav`, token, {
    flightMode: mode
  });
}

export async function getJumpGate(workerId, token, systemSymbol, waypointSymbol) {
  return await run(workerId, 'get', `https://api.spacetraders.io/v2/systems/${systemSymbol}/waypoints/${waypointSymbol}/jump-gate`, token);
}

export async function doSurvey(workerId, token, shipSymbol) {
  return await run(workerId, 'post', `https://api.spacetraders.io/v2/my/ships/${shipSymbol}/survey`, token);
}

export async function doExtraction(workerId, token, shipSymbol, survey) {
  if (survey) {
    return await run(workerId, 'post', `https://api.spacetraders.io/v2/my/ships/${shipSymbol}/extract`, token, {
      survey
    });
  } else {
    return await run(workerId, 'post', `https://api.spacetraders.io/v2/my/ships/${shipSymbol}/extract`, token);
  }
}

export async function getMarket(workerId, token, systemSymbol, waypointSymbol) {
  return await run(workerId, 'get', `https://api.spacetraders.io/v2/systems/${systemSymbol}/waypoints/${waypointSymbol}/market`, token);
}

export async function getShipyard(workerId, token, systemSymbol, waypointSymbol) {
  return await run(workerId, 'get', `https://api.spacetraders.io/v2/systems/${systemSymbol}/waypoints/${waypointSymbol}/shipyard`, token);
}

export async function negotiateContract(workerId, token, shipSymbol) {
  return await run(workerId, 'post', `https://api.spacetraders.io/v2/my/ships/${shipSymbol}/negotiate/contract`, token);
}

export async function accept(workerId, token, contractId) {
  return await run(workerId, 'post', `https://api.spacetraders.io/v2/my/contracts/${contractId}/accept`, token, {
    contractId
  });
}

export async function fulfill(workerId, token, contractId) {
  return await run(workerId, 'post', `https://api.spacetraders.io/v2/my/contracts/${contractId}/fulfill`, token, {
    contractId
  });
}

export async function purchaseCargo(workerId, token, shipSymbol, symbol, amount) {
  return await run(workerId, 'post', `https://api.spacetraders.io/v2/my/ships/${shipSymbol}/purchase`, token, {
    symbol,
    units: amount
  });
}

export async function sellCargo(workerId, token, shipSymbol, symbol, amount) {
  return await run(workerId, 'post', `https://api.spacetraders.io/v2/my/ships/${shipSymbol}/sell`, token, {
    symbol,
    units: amount
  });
}

export async function purchaseShip(workerId, token, waypointSymbol, shipType) {
  return await run(workerId, 'post', `https://api.spacetraders.io/v2/my/ships`, token, {
    shipType,
    waypointSymbol,
  });
}

export async function deliver(workerId, token, contractId, shipSymbol, tradeSymbol, amount) {
  return await run(workerId, 'post', `https://api.spacetraders.io/v2/my/contracts/${contractId}/deliver`, token, {
    shipSymbol,
    tradeSymbol,
    units: amount,
  });
}

export async function shipRefine(workerId, token, shipSymbol, produce) {
  return await run(workerId, 'post', `https://api.spacetraders.io/v2/my/ships/${shipSymbol}/refine`, token, {
    produce
  });
}

export async function shipJettison(workerId, token, shipSymbol, symbol, units) {
  return await run(workerId, 'post', `https://api.spacetraders.io/v2/my/ships/${shipSymbol}/jettison`, token, {
    symbol,
    units
  });
}

export async function getWaypoint(workerId, token, waypointSymbol) {
  const systemSymbol =
    waypointSymbol.split('-')[0] + '-' +
    waypointSymbol.split('-')[1];

  return await run(workerId, 'get', `https://api.spacetraders.io/v2/systems/${systemSymbol}/waypoints/${waypointSymbol}`, token);
}

export async function uninstallMount(workerId, token, shipSymbol, mountSymbol) {
  return await run(workerId, 'post', `https://api.spacetraders.io/my/ships/${shipSymbol}/mounts/remove`, token, {
    symbol: mountSymbol
  });
}

export async function installMount(workerId, token, shipSymbol, mountSymbol) {
  return await run(workerId, 'post', `https://api.spacetraders.io/my/ships/${shipSymbol}/mounts/install`, token, {
    symbol: mountSymbol
  });
}

export async function scanSystems(workerId, token, shipSymbol) {
  return await run(workerId, 'post', `https://api.spacetraders.io/v2/my/ships/${shipSymbol}/scan/systems`, token);
}

export async function registerWithNameAndFaction(workerId, name, faction) {
  const accountToken = process.env.REACT_APP_ACCOUNT_TOKEN;

  if (!accountToken) {
    throw Error('No acccount token found, set the REACT_APP_ACCOUNT_TOKEN env var');
  }

  return await run(workerId, 'post', `https://api.spacetraders.io/v2/register`, accountToken, {
    symbol: name,
    faction: faction,
  });
}

/**
 * Check for a lock and run when not locked.
 *
 * Note: using Lamport's first fast lock
 *
 * See: https://www.cs.rochester.edu/research/synchronization/pseudocode/fastlock.html
 */
async function run(i, method, url, token, data = {}) {

  // Set first lock
  await setX(i);

  // Lock not available, try again
  let y = await getY();
  if (y !== null) {
    console.log(`${i} retry getting lock`);
    await randSleep();
    return await run(i, method, url, token, data);
  } else {
    await setY(i);
  }

  // If first lock has changed, possible contention
  // Note: wait a random time before retry to prevent deadlocks
  if (await getX() !== i) {
    await randSleep();
    if (await getY() !== i) {
      console.log(`${i} retry getting lock, possible contention`);
      return await run(i, method, url, token, data);
    }
  }

  // Run our critical code
  //
  // TODO: Add a retry on (temporary) API errors
  //
  console.log(`${i} running critical code`);
  let response;
  if (method == 'get') {
    response = await get(url, token);
  } else if (method == 'patch') {
    response = await patch(url, token, data);
  } else if (method == 'post') {
    response = await post(url, token, data);
  } else {
    throw Error('Unknown API method: ' + method);
  }

  // Sleep to keep within API limits
  await sleep(0.51);

  // clear lock
  console.log(`${i} done, clearing lock`);
  await setY(null);

  return response;
}

async function randSleep() {

  // miliseconds to sleep
  let rand = 500 + Math.random() * 1000;

  await sleep(rand / 1000);
}

/**
 * Private function
 */
function sleep(s) {
  return new Promise(resolve => setTimeout(resolve, s * 1000));
}

/**
 * Do not export this function, this should be private
 */
async function get(url, token) {
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Authorization": "Bearer " + token,
    },
    redirect: "follow",
  });

  if (response.status == 204) {
    return {};
  }

  if (response.status == 401) {
    throw new Error('Invalid token');
  }

  return response.json();
}

/**
 * Do not export this function, this should be private
 */
async function post(url, token, data) {

  let headers = {
    "Content-Type": "application/json",
  };
  if (token) {
    headers["Authorization"] = "Bearer " + token;
  }

  const response = await fetch(url, {
    method: "POST",
    headers: headers,
    redirect: "follow",
    body: data ? JSON.stringify(data) : undefined,
  });

  if (response.status == 204) {
    return {};
  }

  return response.json();
}

/**
 * Do not export this function, this should be private
 */
async function patch(url, token, data) {
  const response = await fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + token,
    },
    redirect: "follow",
    body: data ? JSON.stringify(data) : undefined,
  });

  if (response.status == 204) {
    return {};
  }

  return response.json();
}

/**
 * Do not export this function, this should be private
 */
async function getX() {
  const rows = await getFromDb();
  //console.log(rows);
  if (rows.length < 1) {
    return null;
  }

  for (let row of rows) {
    if (row.id == 'X') {
      return row.val;
    }
  }

  return null;
}

/**
 * Do not export this function, this should be private
 */
async function getY() {
  const rows = await getFromDb();
  //console.log(rows);
  if (rows.length < 1) {
    return null;
  }

  for (let row of rows) {
    if (row.id == 'Y') {
      return row.val;
    }
  }

  return null;
}

/**
 * Do not export this function, this should be private
 */
async function setX(i) {
  //console.log({ type: 'store', id: 'X', val: i });
  await storeInDb({ id: 'X', val: i });
}

/**
 * Do not export this function, this should be private
 */
async function setY(i) {
  //console.log({ type: 'store', id: 'Y', val: i });
  await storeInDb({ id: 'Y', val: i });
}

/**
 * Do not export this function, this should be private
 */
async function getFromDb() {
  const tables = ['mutex'];
  const table = 'mutex';

  return new Promise((resolve, reject) => {
    const request = window.indexedDB.open("space-trader-mutex", 1);
    request.onerror = (event) => {
      reject('Database error', event);
    };
    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      for (let t of tables) {
        db.createObjectStore(t, { keyPath: "id" });
      }
    };
    request.onsuccess = (event) => {
      event.target.result
        .transaction(table)
        .objectStore(table)
        .getAll().onsuccess = (event) => {
           resolve(event.target.result);
        };
    };
  });
}

/**
 * Do not export this function, this should be private
 */
async function storeInDb(row) {
  const tables = ['mutex'];
  const table = 'mutex';

  return new Promise((resolve, reject) => {
    const request = window.indexedDB.open("space-trader-mutex", 1);
    request.onerror = (event) => {
      reject('Database error', event);
    };
    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      for (let t of tables) {
        db.createObjectStore(t, { keyPath: "id" });
      }
    };
    request.onsuccess = (event) => {
      const store = event.target.result
        .transaction(table, "readwrite")
        .objectStore(table);
      store.put(row);
      resolve();
    };
  });
}

/**
 * Clear locks (note: use only on page load)
 */
export async function clearDb() {
  const tables = ['mutex'];
  const table = 'mutex';

  return new Promise((resolve, reject) => {
    const request = indexedDB.open("space-trader-mutex", 1);
    request.onerror = (event) => {
      reject('Database error', event);
    };
    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      for (let t of tables) {
        db.createObjectStore(t, { keyPath: "id" });
      }
    };
    request.onsuccess = (event) => {
      const store = event.target.result
        .transaction(table, "readwrite")
        .objectStore(table);
      store.clear();
      resolve();
    };
  });
}
